import Axios from 'axios'
import { Dispatch } from 'redux'

import { ActionResponse, Id } from 'util/types/index'
import { PartnerProduct, ProductSectionData } from '../types'
import { clearAlert, createAlert, handleError } from 'util/modules/Alert/redux/actions'
import { getPartnerProduct } from './product'

export function createSectionItem (partnerId: Id, pProdId: Id, sId: Id) {
  return async (dispatch: Dispatch): Promise<ActionResponse<PartnerProduct>> => {
    return Axios
      .post(`/partner/${partnerId}/product/${pProdId}/section/${sId}/item`)
      .then(res => res.data)
      .then(async res => {
        if (res?.status === 'success' && res?.data) {
          await getPartnerProduct(partnerId, pProdId)(dispatch)
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao adicionar o item')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}

export function updateSectionItem (
  partnerId: Id, pProdId: Id, sId: Id, id: Id, data: Partial<ProductSectionData>
) {
  return async (dispatch: Dispatch): Promise<ActionResponse<PartnerProduct>> => {
    return Axios
      .put(`/partner/${partnerId}/product/${pProdId}/section/${sId}/item/${id}`, data)
      .then(res => res.data)
      .then(async res => {
        if (res?.status === 'success' && res?.data) {
          await getPartnerProduct(partnerId, pProdId)(dispatch)
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao atualizar o item')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}

export function deleteSectionItem (partnerId: Id, pProdId: Id, sId: number, id: Id) {
  return async (dispatch: Dispatch): Promise<ActionResponse<PartnerProduct>> => {
    return Axios
      .delete(`/partner/${partnerId}/product/${pProdId}/section/${sId}/item/${id}`)
      .then(res => res.data)
      .then(async res => {
        if (res?.status === 'success') {
          await getPartnerProduct(partnerId, pProdId)(dispatch)
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao remover o item da sessão')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}
